var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button is-primary",on:{"click":_vm.open}},[_vm._v("Add Songwriter")]),_c('form-modal',{attrs:{"type":"songwriter","title":"Add Songwriter","model":_vm.songwriter,"message":"You can add more details later.","isModal":_vm.isModal},on:{"clear-modal":_vm.clearModal,"save-record":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }